import { useState } from "react";
import { Link } from "react-router-dom";

const LOGO = "https://public.readdy.ai/ai/img_res/f49e481e-6249-471e-b877-3a3cae2fc3b1.png";
const NEWSLETTER_URL = "https://readdy.ai/api/form/d6uvdjd1l1ubpb129a70";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    const body = new URLSearchParams();
    body.append("email", email);
    try {
      await fetch(NEWSLETTER_URL, { method: "POST", body, headers: { "Content-Type": "application/x-www-form-urlencoded" } });
      setSubmitted(true);
      setEmail("");
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer style={{ backgroundColor: "#2A1F1C" }}>
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-8">
        {/* Brand + Newsletter */}
        <div className="lg:col-span-2">
          <img src={LOGO} alt="BE:NAIL" className="h-12 w-auto object-contain mb-6" />
          <p className="text-[#C9A86A] text-xs tracking-[0.2em] uppercase mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            上質なネイル情報をお届けします
          </p>
          <p className="text-[#9E8E80] text-sm mb-5 leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            最新トレンドやキャンペーン情報を<br />メールでお知らせします
          </p>
          {submitted ? (
            <p className="text-[#C9A86A] text-sm" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              ご登録ありがとうございます
            </p>
          ) : (
            <form
              data-readdy-form
              onSubmit={handleNewsletterSubmit}
              className="flex gap-2"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="メールアドレス"
                required
                className="flex-1 bg-transparent border border-[#4A3830] text-white placeholder-[#6B5548] px-4 py-2.5 rounded-full text-sm outline-none focus:border-[#C9A86A] transition-colors"
                style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
              />
              <button
                type="submit"
                disabled={submitting}
                className="w-10 h-10 flex items-center justify-center bg-[#B8956A] rounded-full hover:bg-[#A07B55] transition-colors cursor-pointer shrink-0"
              >
                <i className="ri-send-plane-line text-white text-sm"></i>
              </button>
            </form>
          )}
        </div>

        {/* Nav Columns */}
        <div className="lg:col-span-3 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <p className="text-[#C9A86A] text-xs tracking-[0.15em] uppercase mb-4 font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>メニュー</p>
            <ul className="space-y-2.5">
              {["ワンカラー", "フレンチ", "グラデーション", "ネイルアート", "ハンドケア"].map((item) => (
                <li key={item}>
                  <Link to="/gallery" className="text-[#9E8E80] hover:text-white text-sm transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[#C9A86A] text-xs tracking-[0.15em] uppercase mb-4 font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>サロン情報</p>
            <ul className="space-y-2.5">
              {["アクセス", "営業時間・料金", "よくある質問"].map((item) => (
                <li key={item}>
                  <Link to="/about" className="text-[#9E8E80] hover:text-white text-sm transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[#C9A86A] text-xs tracking-[0.15em] uppercase mb-4 font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>ご予約</p>
            <ul className="space-y-2.5">
              {["オンライン予約", "指名予約", "キャンセルポリシー"].map((item) => (
                <li key={item}>
                  <Link to="/booking" className="text-[#9E8E80] hover:text-white text-sm transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-[#C9A86A] text-xs tracking-[0.15em] uppercase mb-4 font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>フォロー</p>
            <ul className="space-y-2.5">
              {[
                { label: "Instagram", icon: "ri-instagram-line" },
                { label: "LINE", icon: "ri-line-line" },
                { label: "Facebook", icon: "ri-facebook-line" },
              ].map(({ label, icon }) => (
                <li key={label}>
                  <a href="#" className="text-[#9E8E80] hover:text-white text-sm transition-colors cursor-pointer flex items-center gap-2" style={{ fontFamily: "'Noto Sans JP', sans-serif" }} rel="nofollow">
                    <span className="w-4 h-4 flex items-center justify-center"><i className={`${icon} text-sm`}></i></span>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#3D2E2A]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#6B5548] text-xs" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            &copy; 2025 BE:NAIL. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {[
              { icon: "ri-instagram-line" },
              { icon: "ri-line-line" },
              { icon: "ri-facebook-line" },
            ].map(({ icon }) => (
              <a
                key={icon}
                href="#"
                rel="nofollow"
                className="w-8 h-8 flex items-center justify-center border border-[#4A3830] rounded-md text-[#6B5548] hover:text-white hover:border-[#9E8E80] transition-colors cursor-pointer"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <div className="flex items-center gap-4">
            <a href="#" rel="nofollow" className="text-[#6B5548] hover:text-[#9E8E80] text-xs transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>プライバシーポリシー</a>
            <a href="#" rel="nofollow" className="text-[#6B5548] hover:text-[#9E8E80] text-xs transition-colors cursor-pointer" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>利用規約</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
